import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const reopenCookiePrefs = () => {
    window.dispatchEvent(new CustomEvent("connexis:open-cookie-prefs"));
  };

  return (
    <footer className="border-t border-border bg-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-y-10 gap-x-8 items-start">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-slate-900 text-white">
                <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 7h7M4 12h12M4 17h7" strokeLinecap="round" />
                  <circle cx="18" cy="7" r="2.2" fill="#0055FF" stroke="none" />
                  <circle cx="18" cy="17" r="2.2" fill="#0055FF" stroke="none" />
                </svg>
              </span>
              <span className="text-[15px] font-semibold tracking-tight text-slate-900">Connexis<span className="text-primary">.</span></span>
            </div>
            <p className="mt-4 text-sm text-slate-600 max-w-sm">
              Infrastructure for financial growth — customer acquisition, AI operational systems and enterprise-grade routing for modern financial brands.
            </p>
            <address className="mt-6 not-italic text-xs text-slate-500 leading-relaxed" data-testid="footer-address">
              <span className="block font-medium text-slate-700">Connexis Group Ltd</span>
              71-75 Shelton Street<br />
              Covent Garden, London<br />
              WC2H 9JQ<br />
              United Kingdom
              <span className="block mt-1.5">Company no. <span className="font-mono">17214446</span></span>
            </address>
            <p className="mt-5 text-xs text-slate-500">© {new Date().getFullYear()} Connexis Group Ltd. All rights reserved.</p>
          </div>
          <FootCol title="Platform" links={[["/solutions","Solutions"],["/services","Managed Services"],["/pay-per-call","Pay-per-call"],["/integrations","Integrations"],["/benchmark-report","2026 CPL Benchmarks"],["/ai-systems","AI Systems"],["/enterprise","Infrastructure"],["/pricing","Pricing"],["/inside-connexis","Inside Connexis"],["/why-connexis","vs LeadProsper / LeadByte"]]} />
          <FootCol title="Partners" links={[["/start","Launch Partner programme"],["/partners","Partner programme"],["/partner-with-us","Call centres & media partners"],["/buy-leads","Buy leads"],["/publisher/apply","Sell us your leads"],["/partners/apply","Refer buyers"],["/leaderboard","Partner leaderboard"]]} />
          <FootCol title="Lending network" links={[["/business-funding","Business funding, explained"],["/property-finance","Property & development finance"],["/healthcare-finance","Healthcare & care home finance"],["/manufacturing-finance","Manufacturing & industrial finance"],["/hospitality-finance","Hospitality & leisure finance"],["/lending-network","How the network works"],["/introducer/apply","Become an introducer"],["/lender/apply","Become a lender partner"],["/introducer/login","Introducer portal"],["/lender/login","Lender desk"],["/apply/status","Track an application"]]} />
          <FootCol title="Company" links={[["/about","About"],["/careers","Careers"],["/customers","Customer stories"],["/insights","Insights"],["/faq","FAQ"],["/changelog","Changelog"],["/roadmap","Roadmap"],["/contact","Contact"],["/book-demo","Book a demo"],["/login","Sign in"],["/docs","Docs"],["/status","Status"]]} />
          <FootCol title="Legal" links={[
            ["/trust","Trust Center"],
            ["/legal/privacy","Privacy Policy"],
            ["/legal/cookies","Cookie Policy"],
            ["/legal/terms-buyer","Buyer Terms"],
            ["/legal/terms-publisher","Publisher Terms"],
            ["/legal/terms-affiliate","Affiliate Terms"],
            ["/legal/dpa","DPA"],
            ["/legal/acceptable-use","Acceptable Use"],
          ]} />
        </div>
        <div className="mt-12 pt-6 border-t border-border/80 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-500">
          <p>Connexis Group is FCA-aware. Lead delivery, AI scripts and data flows are designed with UK &amp; EU regulatory frameworks (GDPR, FCA CONC, TCPA) in mind.</p>
          <div className="flex items-center gap-4 flex-wrap">
            <button
              onClick={reopenCookiePrefs}
              className="hover:text-slate-900 transition-colors"
              data-testid="footer-cookie-prefs"
            >
              Cookie preferences
            </button>
            <span className="text-slate-300">·</span>
            <Link to="/status" className="inline-flex items-center gap-1.5 hover:text-slate-900"><span className="size-1.5 rounded-full bg-emerald-500" /> All systems operational</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FootCol({ title, links }) {
  return (
    <div>
      <h4 className="text-xs font-semibold tracking-widest uppercase text-slate-500">{title}</h4>
      <ul className="mt-4 space-y-2.5">
        {links.map(([href, label], i) => (
          <li key={i}><Link to={href} className="text-sm text-slate-700 hover:text-primary transition-colors">{label}</Link></li>
        ))}
      </ul>
    </div>
  );
}
